import { copyCodeToClipboard, openMessage } from "utils/misc";
import CopyOutlined from "@ant-design/icons/CopyOutlined";
import Button from "common/Buttons/Button";
import { CSSProperties, FC } from "react";
import { getCopyMessage } from "@shared/common/CopyToClipboard/utils";
import type { ButtonProps } from "antd";

interface CopyElementProps {
  text: string;
  name?: string;
  style?: CSSProperties;
  onCopyClick?: () => void;
}

const CopyToClipboardIcon = ({
  text,
  style,
  name,
  onCopyClick,
}: CopyElementProps) => {
  return (
    <CopyOutlined
      onClick={(e) => {
        copyCodeToClipboard(text).catch(() => {});
        openMessage(getCopyMessage(name), "info");
        e.stopPropagation();
        onCopyClick?.();
      }}
      style={{
        marginLeft: "12px",
        ...style,
      }}
    />
  );
};

export const CopyToClipboardButton: FC<CopyElementProps & ButtonProps> = ({
  text,
  name,
  style,
  children,
  onCopyClick,
  ...props
}) => {
  return (
    <Button
      onClick={() => {
        copyCodeToClipboard(text).catch(() => {});
        openMessage(getCopyMessage(name), "info");
        onCopyClick?.();
      }}
      shape="round"
      style={style}
      {...props}
    >
      {children || "Copy"}
    </Button>
  );
};

export default CopyToClipboardIcon;
